import React from 'react'
import { Theme, ThemeSwitcher, WhenTheme } from 'widgets/theme-switcher'
import ScheduleHighlightCards from 'widgets/shifts/ScheduleHightlightCards'
import ConstrainedScheduleSlotsCollection from 'widgets/shifts/ConstrainedScheduleSlotsCollection'
import * as UI from 'ui'
import FetchSchedule from './FetchSchedule'
import ScheduleHeader from './ScheduleHeader'
import ScheduleCalendarTheme from './ScheduleCalendarTheme'
import ScheduleStaffListTheme from './ScheduleStaffListTheme'
import ScheduleActions from 'pages/app/shifts/partials/ScheduleActions'

export default function Schedule ({ mode = 'view' }) {
  return (
    <Theme enum='schedule_themes' defaultTheme='calendar'>
      <FetchSchedule mode={mode}>

        {mode === 'plan'
          ? (
            <UI.HighlightCardsWrapper>
              <ScheduleHighlightCards />
            </UI.HighlightCardsWrapper>
            )
          : null}

        <ScheduleHeader>
          {mode === 'plan'
            ? (
              <UI.ButtonWrap>
                <WhenTheme type='calendar'>
                  <ScheduleActions />
                </WhenTheme>
                <UI.ButtonTabs>
                  {/* <ThemeSwitcher type='list' enum='schedule_themes' /> */}
                  <ThemeSwitcher type='calendar' enum='schedule_themes' />
                  <ThemeSwitcher type='staff' enum='schedule_themes' />
                </UI.ButtonTabs>
              </UI.ButtonWrap>
              )
            : null/* (
              <UI.ButtonWrap>
                <UI.ButtonTabs>
                  <ThemeSwitcher type='list' enum='schedule_themes' />
                  <ThemeSwitcher type='calendar' enum='schedule_themes' />
                </UI.ButtonTabs>
              </UI.ButtonWrap>
              ) */}
        </ScheduleHeader>

        <ConstrainedScheduleSlotsCollection>
          {/* <ScheduleListTheme mode={mode}/> */}
          <ScheduleCalendarTheme mode={mode} />
          {mode === 'plan'
            ? (
              <ScheduleStaffListTheme />
              )
            : null}
        </ConstrainedScheduleSlotsCollection>

      </FetchSchedule>
    </Theme>
  )
}
